<template>      
    <div>
          <div>
              <h5 class="center">Select your activity</h5>
          </div>
          <div class="row">
            <div class="input-field col s12" v-for="activity in activities" :key="activity.name">
                  <label>
                      <input name="activity" type="radio" checked v-model="trainingPrograms" @change="changePrograms($event)" :value="activity.programs"/>
                      <span>{{activity.name}} <i v-for="i in activity.programs.length" :key="i" class="material-icons tiny blue-text">today</i></span>
                  </label>
              </div>
          </div>
      </div>
</template>
<script>
import api from '@/api'
import M from 'materialize-css'
export default {
  name: 'training',
  props: {
    'user': Object,
    'callback': Function
  },
  data: function () {
    return {
      activities: [],
      trainingPrograms: []
    }
  },
  created () {
    this.trainingPrograms = this.user.athlete.trainingPrograms
    this.activities = api.getActivityList()
  },
  methods: {
    changePrograms: function (e) {
      const programs = e.target._value
      this.user.athlete.trainingPrograms = programs
      this.user.athlete.sessionsPerWeek = programs.length
      api.update(this.user)
      this.$events.$emit('selected-activity-changed', {})
      M.toast({html: 'Selected activity changed!'})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/athlete/Training.vue